module.exports = __webpack_public_path__ + "img/activity_22.f454b390.jpg";